'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { Button } from '@holistic/components';

import type { NavCategory } from '@/types/navigation';

import NavList from './nav-list';
import UserHoverCard from './user-hover-card';

export default function HeaderActions({
  categories,
}: {
  categories: NavCategory[] | null;
}) {
  const pathname = usePathname();
  const authPaths = ['login', 'register', 'sifremi_unuttum', 'reset-password'];

  const isAuthPath = authPaths.some((path) => pathname.includes(path));

  if (isAuthPath) return null;

  return (
    <>
      <div className="hidden lg:flex">
        <NavList categories={categories} />
      </div>
      <div className="flex items-center justify-center gap-4">
        {/* Mobilde kullanıcı menüsü yan menüde (MobileSheet) yer alıyor. */}
        <div className="hidden lg:flex">
          <UserHoverCard />
        </div>
        {/* Dar ekranda tam etiket logo + hamburger ile birlikte 390px'e
            sığmayıp sayfayı yana kaydırıyordu; mobilde kısa etiket.
            `asChild`: dokunma hedefi yalnızca metin değil butonun tamamı
            olsun (button içinde <a> da geçersiz HTML'di). */}
        <Button
          asChild
          size={'lg'}
          className="rounded-full max-sm:h-10 max-sm:px-4 max-sm:text-xs"
        >
          <Link href={'/talep'}>
            <span className="sm:hidden">Tamir Ettir</span>
            <span className="max-sm:hidden">Cihazımı Tamir Ettir</span>
          </Link>
        </Button>
      </div>
    </>
  );
}
